import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Field, NativeSelect } from "@/components/visit/VisitBits";
import PhotoUploader from "@/components/visit/PhotoUploader";
import { LOCAL_BODY_TYPES, sectionFiles, setPath } from "@/lib/visitSchema";

export default function NeighborStep({ form, setForm, uploads }) {
  const set = (path) => (v) => setForm((prev) => setPath(prev, path, v?.target ? v.target.value : v));
  return (
    <div className="space-y-5" data-testid="visit-step-neighbor-panel">
      <div>
        <div className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-2">Neighbor verification</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <Field label="Neighbor name"><Input value={form.neighbor.name} onChange={set("neighbor.name")} data-testid="visit-neighbor-name" /></Field>
          <Field label="Neighbor phone"><Input type="tel" inputMode="numeric" value={form.neighbor.phone} onChange={set("neighbor.phone")} data-testid="visit-neighbor-phone" /></Field>
          <Field label="Neighbor address" className="md:col-span-2"><Textarea rows={2} value={form.neighbor.address} onChange={set("neighbor.address")} data-testid="visit-neighbor-address" /></Field>
        </div>
        <div className="mt-3">
          <PhotoUploader section="neighbor" label="Neighbor verification photo" hint="Photo with the neighbor at the property or of their signed confirmation."
            files={sectionFiles(form, "neighbor")} uploads={uploads} testId="visit-upload-neighbor" />
        </div>
      </div>
      <div className="border-t border-slate-200 pt-4">
        <div className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-2">Local body verification</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
          <Field label="Local body"><NativeSelect value={form.neighbor.local_body_type} onChange={set("neighbor.local_body_type")} options={LOCAL_BODY_TYPES} placeholder="Panchayat / Nagar Parishad / Nagar Palika" testId="visit-local-body-type" /></Field>
        </div>
        <PhotoUploader section="local_body" label="Panchayat / Nagar Parishad / Nagar Palika deed verification photo" accept="image/*,application/pdf"
          hint="Photo of the deed / record verified at the local body office." files={sectionFiles(form, "local_body")} uploads={uploads} testId="visit-upload-local-body" />
      </div>
    </div>
  );
}
